export const CORE_FIELD_VALUE_KIND = {
    needsApproval: 'boolean',
    checkInRequired: 'boolean',
    underReviewRequired: 'boolean',
    photoRequired: 'boolean',
    promotionLinked: 'boolean',
    assigneeCount: 'number',
    hasOnSiteReps: 'boolean',
};
//# sourceMappingURL=core-field-value-kind.js.map